import React, { Component } from "react";
import Slick from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class Slider extends Component {
  render() {
    return (
      <div
        className="slider-container"
        style={{
          width: 450,
          height: 390,
          marginRight: 30
        }}
      >
        <Slick
          infinite={this.props.images.length > 1}
          autoplay={true}
          slidesToShow={1}
          slidesPerRow={1}
          autoplaySpeed={10000}
        >
          {this.props.images.map(image => (
            <div
              style={{
                width: 450,
                height: 390,
                display: "flex",
                justifyContent: "center"
              }}
            >
              <img src={image} alt="Camera" key={image} />
            </div>
          ))}
        </Slick>
      </div>
    );
  }
}

export default Slider;



// WEBPACK FOOTER //
// ./src/components/Slider.js